// extracted by mini-css-extract-plugin
export var editInput = "_j5-0";
export var editInputCompact = "_j5-2";
export var editInputLarge = "_j5-1";
export var editInputSmall = "_j5-3";